"use strict";

exports.__esModule = !0, exports.default = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base")),
    _react = _interopRequireDefault(require("react")),
    _constants = require("../constants");

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

var Loading = function (a) {
  var b = a.props;
  return b.loadingRenderer ? b.loadingRenderer({
    props: b
  }) : _react.default.createElement(LoadingComponent, {
    className: _constants.LIB_NAME + "-loading",
    color: b.color
  });
},
    LoadingComponent = (0, _styledBase.default)("div", {
  target: "e1l5cpc30",
  label: "LoadingComponent"
})("@keyframes dual-ring-spin{0%{transform:rotate(0deg);}100%{transform:rotate(180deg);}}padding:0 5px;display:block;width:auto;height:auto;:after{content:' ';display:block;width:16px;height:16px;border-radius:50%;border-width:1px;border-style:solid;border-color:", function (a) {
  var b = a.color;
  return b;
}, " transparent;animation:dual-ring-spin 0.7s ease-in-out infinite;margin:0 0 0 -10px;}" + ("production" === process.env.NODE_ENV ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL0xvYWRpbmcuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBV21DIiwiZmlsZSI6Ii4uLy4uL3NyYy9jb21wb25lbnRzL0xvYWRpbmcuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgTElCX05BTUUgfSBmcm9tICcuLi9jb25zdGFudHMnO1xuXG5jb25zdCBMb2FkaW5nID0gKHsgcHJvcHMgfSkgPT5cbiAgcHJvcHMubG9hZGluZ1JlbmRlcmVyID8gKFxuICAgIHByb3BzLmxvYWRpbmdSZW5kZXJlcih7IHByb3BzIH0pXG4gICkgOiAoXG4gICAgPExvYWRpbmdDb21wb25lbnQgY2xhc3NOYW1lPXtgJHtMSUJfTkFNRX0tbG9hZGluZ2B9IGNvbG9yPXtwcm9wcy5jb2xvcn0gLz5cbiAgKTtcblxuY29uc3QgTG9hZGluZ0NvbXBvbmVudCA9IHN0eWxlZC5kaXZgXG4gIEBrZXlmcmFtZXMgZHVhbC1yaW5nLXNwaW4ge1xuICAgIDAlIHtcbiAgICAgIHRyYW5zZm9ybTogcm90YXRlKDBkZWcpO1xuICAgIH1cbiAgICAxMDAlIHtcbiAgICAgIHRyYW5zZm9ybTogcm90YXRlKDE4MGRlZyk7XG4gICAgfVxuICB9XG5cbiAgcGFkZGluZzogMCA1cHg7XG4gIGRpc3BsYXk6IGJsb2NrO1xuICB3aWR0aDogYXV0bztcbiAgaGVpZ2h0OiBhdXRvO1xuXG4gIDphZnRlciB7XG4gICAgY29udGVudDogJyAnO1xuICAgIGRpc3BsYXk6IGJsb2NrO1xuICAgIHdpZHRoOiAxNnB4O1xuICAgIGhlaWdodDogMTZweDtcbiAgICBib3JkZXItcmFkaXVzOiA1MCU7XG4gICAgYm9yZGVyLXdpZHRoOiAxcHg7XG4gICAgYm9yZGVyLXN0eWxlOiBzb2xpZDtcbiAgICBib3JkZXItY29sb3I6ICR7KHsgY29sb3IgfSkgPT4gY29sb3J9IHRyYW5zcGFyZW50O1xuICAgIGFuaW1hdGlvbjogZHVhbC1yaW5nLXNwaW4gMC43cyBlYXNlLWluLW91dCBpbmZpbml0ZTtcbiAgICBtYXJnaW46IDAgMCAwIC0xMHB4O1xuICB9XG5gO1xuXG5leHBvcnQgZGVmYXVsdCBMb2FkaW5nO1xuIl19 */")),
    _default = Loading;

exports.default = _default;